function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Artboard");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Fire",
  transform: "translate(8.000000, 6.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.06363,22.9628679 C17.06363,22.9628679 19.8000008,20.526297 19.8000008,16.1237425 C19.8000008,11.721188 16.1667812,9.70167785 13.559155,7.23165298 C10.95262,4.76051296 11.2308395,0 11.2308395,0 C11.2308395,0 7.58343615,3.21828072 6.37781822,6.74991449 C4.71286532,11.6330923 5.47551413,14.4075492 5.47551413,14.4075492 C5.47551413,14.4075492 4.36154499,13.6169182 3.59234984,12.1304427 C2.82315469,10.6450824 2.79369615,8.21966293 2.79369615,8.21966293 C2.79369615,8.21966293 0.201344847,12.2163081 0.0256846784,15.0454066 C-0.14997549,17.8756202 0.464289571,22.9628679 5.38713852,22.9628679 C10.3088964,22.9628679 11.0988216,16.6177475 11.0551794,15.3598748 C11.010446,14.1031172 10.4845566,12.0367714 10.4845566,12.0367714 C10.4845566,12.0367714 14.1603274,14.2380486 14.3359876,17.2466839 C14.5116478,20.2553191 12.1833322,23.4000009 12.1833322,23.4000009",
  id: "Stroke-208"
})));

var SvgCaution = function SvgCaution(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caution.e79cf520.svg";
export { ForwardRef as ReactComponent };